var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

// Call the function when DOM is ready
document.addEventListener('DOMContentLoaded', setupFootnotes);

pagination(false);

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover') && !document.querySelector('.cover').classList.contains('half')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

if (document.querySelector('.cover') && document.querySelector('.cover').classList.contains('half')) {
    body.classList.add('portal-visible');
}

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}


function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}
